import { useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { Context } from "./shared/Context/Context";
import "./App.css";
import Navbar from "./components/Navbar/Navbar";
import Home from "./pages/Home/Home";
import { API } from "./shared/Api/Api";
import Info from "./pages/Info/Info";
import InfoDetail from "./pages/Info/InfoDetail/InfoDetail";
import Contact from "./pages/Contact/Contact";
import Winners from "./pages/Winners/Winners";
import Login from "./pages/Users/Login/Login";

import { IntlProvider } from "react-intl";
import Spanish from "./lang/es.json";
import English from "./lang/en.json";
import German from "./lang/de.json";

function App() {
  const [tabletOrLess, setTabletOrLess] = useState();
  const [jwt, setJwt] = useState(localStorage.getItem("token") || null);
  const [isRegistered, setIsRegistered] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [lang, setLang] = useState(Spanish);
  const navigate = useNavigate();

  console.log(navigator.language);

  const checkSession = async (token) => {
    try {
      const result = await API.post("user/checksession");
      localStorage.setItem("user", JSON.stringify(result.data));
      localStorage.setItem("token", token);
      navigate("/");
    } catch (error) {
      navigate("/login");
    }
  };

  useEffect(() => {
    if (window.matchMedia("(min-width: 805px)").matches) {
      setTabletOrLess(false);
    } else {
      setTabletOrLess(true);
    }
  }, []);

  useEffect(() => {

    if (navigator.language === "es-ES") {
      setLang(Spanish)
    } else if (navigator.language === "en-EN") {
      setLang(English)
    } else if (navigator.language === "de-DE") {
      setLang(German)
    }

    if (localStorage.getItem("token")) {
      checkSession(localStorage.getItem("token"));
      setIsRegistered(true);
      if (localStorage.getItem("user")) {
        const user = localStorage.getItem("user");
        if (JSON.parse(user).rol === "admin") {
          setIsAdmin(true);
        } else {
          setIsAdmin(false);
        }
      }
    }
  }, []);

  return (
    <Context.Provider
      value={{
        jwt,
        setJwt,
        isRegistered,
        setIsRegistered,
        isAdmin,
        setIsAdmin,
        tabletOrLess,
        setTabletOrLess,
        lang,
        setLang
      }}
    >
      <IntlProvider locale={navigator.language} messages={lang}>
        <Navbar />
        <Routes>
          <Route index element={<Home />}></Route>
          <Route path="novedades" element={<Info />}></Route>
          <Route path="novedades/:id" element={<InfoDetail />} />
          <Route path="contacto" element={<Contact />}></Route>
          <Route path="ganadores" element={<Winners />}></Route>
          <Route path="login" element={<Login />}></Route>
          <Route path="*" element={<Home />} />
        </Routes>
      </IntlProvider>
    </Context.Provider>
  );
}

export default App;
